// Formatage des crédits — fractionnaires (1 vidéo = 1 crédit, 1 image = 0,1 crédit).
// Affiche « 12 » et non « 12.00 », mais « 0,3 » et non « 0.30000000000000004 ».

export const EUROS_PER_CREDIT = 4; // 200 € → 50 vidéos
export const VIDEO_COST = 1;
export const IMAGE_COST = 0.1;

export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// « 1,5 » · « 12 » · « 0,1 »
export function fmtCredits(n) {
  const v = round2(n);
  return (Number.isInteger(v) ? String(v) : v.toFixed(2).replace(/0$/, "")).replace(".", ",");
}

// « 2,5 crédits » / « 1 crédit » / « Gratuit »
export function creditLabel(n) {
  const v = round2(n);
  if (v === 0) return "Gratuit";
  return `${fmtCredits(v)} crédit${v > 1 ? "s" : ""}`;
}

export const videosFor = (credits) => Math.floor(round2(credits) / VIDEO_COST);
export const imagesFor = (credits) => Math.floor(round2(credits) / IMAGE_COST);
export const creditsToEuros = (credits) => round2(round2(credits) * EUROS_PER_CREDIT);

// « 12 vidéos ou 120 images » — traduit un solde en usages concrets.
export const yieldLabel = (credits) => `${videosFor(credits)} vidéos ou ${imagesFor(credits)} images`;
